import { useUpdateEffect } from './useUpdateEffect';
import { SelectedG500LiteMasterInfoType } from './useStateSelectedG500LiteMasterInfo';

import { MasterInfo } from '../../type/MasterInfoType';
import { DialogType } from '../../type/DialogType';
import { all, g500LiteGetType } from '../../const/commonConst';
import { getG500LiteMasterInfoWithOrganizationIdHandler } from '../../handler/getG500LiteMasterInfoWithOrganizationIdHandler';

type InputType = {
	getType: (typeof g500LiteGetType)[keyof typeof g500LiteGetType];
	selectedG500LiteMasterInfo: SelectedG500LiteMasterInfoType;
	setSelectedG500LiteMasterInfo: React.Dispatch<React.SetStateAction<SelectedG500LiteMasterInfoType>>;
	masterInfo: MasterInfo;
	setMasterInfo: React.Dispatch<React.SetStateAction<MasterInfo>>;
	setDialog: (value: React.SetStateAction<DialogType>) => void;
};

const initSelectedG500LiteMasterInfo = {
	selectedG500LiteOrganizationInfo: all,
	selectedG500LiteCarInfo: all,
	selectedG500LiteDriverInfo: all,
};

/**
 * G500Liteマスタデータの状態管理用カスタムフック
 */
export const useEffectG500LiteMasterInfo = (input: InputType) => {
	const { getType, selectedG500LiteMasterInfo, setSelectedG500LiteMasterInfo, masterInfo, setMasterInfo, setDialog } = input;

	// G500Liteの組織選択後のマスタデータ取得
	useUpdateEffect(() => {
		const getSearchCriterionForG500Lite = async () => {
			const [dialog, g500LiteMasterInfo] = await getG500LiteMasterInfoWithOrganizationIdHandler(
				getType,
				selectedG500LiteMasterInfo.selectedG500LiteOrganizationInfo.id,
			);

			if (!g500LiteMasterInfo) {
				setMasterInfo({ ...masterInfo, g500LiteCarInfoList: [], g500LiteDriverInfoList: [] });
				setSelectedG500LiteMasterInfo(initSelectedG500LiteMasterInfo);
				setDialog(dialog);
				return;
			}

			// 取得タイプにより更新するマスタ情報を変える
			if (getType === g500LiteGetType.carInfo) {
				setMasterInfo({
					...masterInfo,
					g500LiteCarInfoList: g500LiteMasterInfo.g500LiteCarInfoList,
				});
			} else {
				setMasterInfo({
					...masterInfo,
					g500LiteDriverInfoList: g500LiteMasterInfo.g500LiteDriverInfoList,
				});
			}
		};

		getSearchCriterionForG500Lite();
	}, [selectedG500LiteMasterInfo.selectedG500LiteOrganizationInfo.id]);
};
